import type { ReactNode } from 'react'
import { Card } from '@/components/ui/card'

export function InvestigationMetaTile({
  icon,
  label,
  primary,
  secondary,
}: {
  icon: ReactNode
  label: string
  primary: ReactNode
  secondary?: ReactNode
}) {
  return (
    <Card size="compact" className="p-4">
      <div className="mb-2 flex items-center gap-2 text-3xs font-medium uppercase tracking-widest text-muted-foreground/70">
        <span className="text-muted-foreground">{icon}</span>
        {label}
      </div>
      <div className="text-sm font-medium text-foreground">{primary}</div>
      {secondary && <div className="mt-2 text-xs text-muted-foreground">{secondary}</div>}
    </Card>
  )
}
